import signedInUser from './common/util/signed-in-user';

const AccountNotifications = require(`./${process.env.ENTRY_POINT}/components/AccountNotifications/AccountNotificationsComponent.js`).default;
let notificationsComponent = null;

const radio = (app) => {
  app.channel.on('get:account:notifications', async (options) => {
    if (!notificationsComponent && signedInUser()) {
      notificationsComponent = new AccountNotifications(options);
      notificationsComponent.view.render();
    } else if (!signedInUser()) {
      app.channel.trigger('notifications:notRendered', notificationsComponent);
    }
    app.channel.trigger('notifications:rendered', notificationsComponent);
  });
};

export default AccountNotifications;
export { radio };
